import type { ReactNode } from 'react'
import { ActivityIndicator, View } from 'react-native'

import { Iframe } from '@/src/elements/iframe'
import { CommonHeader } from '@/src/elements/templates/CommonLayout'
import { TEST_ID } from '@/src/general/constants/testId'
import { ErrorScreen } from '@/src/general/ui/screens/ErrorScreen'

import { usePageQuery } from '../services/usePageQuery'

type TPageScreenProps = { slug: string }

export const PageScreen = ({ slug }: TPageScreenProps): ReactNode => {
  const { data, error } = usePageQuery(slug)

  if (error) return <ErrorScreen error={error} defaultErrorKey="common.error.unknown" />

  if (!data) return <ActivityIndicator />

  return (
    <>
      <View className="z-header bg-white">
        <CommonHeader />
      </View>
      <View className="z-0 grow">
        <Iframe
          // -mt-11 to hide the iframe header
          // h-[105%] to hide the cookie consent
          className="z-0 -mt-11 h-[calc(100%+14rem)] w-full shrink-0 sm:h-[calc(100%+8rem)]"
          src={data.url}
          title={data.title}
          testID={TEST_ID.PAGE.IFRAME}
        />
      </View>
    </>
  )
}
